export const getFormattedDate = (unixDate: number) => {
  const date = new Date(unixDate * 1000);
  const months = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];
  return `${months[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`;
}

export const isValidUrl = (value) => {
  return /^(?!:\/\/)([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/.test(value.trim())
}

const MAX_EMAIL_LENGTH = 254

/** Linear-time check equivalent to /^[^\s@]+@[^\s@]+\.[^\s@]+$/ (avoids ReDoS). */
export const isValidEmail = (value: string): boolean => {
  const email = value.trim()
  if (!email || email.length > MAX_EMAIL_LENGTH) return false

  const atIndex = email.indexOf('@')
  if (atIndex <= 0 || email.lastIndexOf('@') !== atIndex) return false

  const local = email.slice(0, atIndex)
  const domain = email.slice(atIndex + 1)
  if (!local || !domain) return false

  for (const part of [local, domain]) {
    for (let i = 0; i < part.length; i++) {
      const code = part.charCodeAt(i)
      if (code <= 32 || code === 64) return false
    }
  }

  const dotIndex = domain.indexOf('.')
  return dotIndex > 0 && dotIndex < domain.length - 1
}

/** Removes HTML tags in O(n) without regex (avoids ReDoS). */
export const stripHtmlTags = (html: string): string => {
  let result = ''
  let i = 0
  while (i < html.length) {
    if (html.charCodeAt(i) === 60) {
      i++
      while (i < html.length && html.charCodeAt(i) !== 62) i++
      if (i < html.length) i++
    } else {
      result += html[i]
      i++
    }
  }
  return result
}

export const normalizeTextContent = (html: string): string =>
  stripHtmlTags(html).split('\u00a0').join(' ')





